import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import instance from "../instance"
import { toast } from "react-toastify"
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const useFetchUsers=(filters)=>{
    const fetchUsers = async() =>{
      try{

        // const {data}= await instance.get(`/api/user/all` )
          const {data}= await instance.get(`/api/user/all?pageNumber=${filters.pageNumber}&pageSize=${filters.pageSize}&search=${filters.search}&orgId=${filters.orgId}` )
          return data
      } 
      catch(ex){
        console.log({ex})
      }
    }
    const query= useQuery({
        queryKey:['fetch users',filters],
        queryFn:fetchUsers,
    })
    return query
}

export const useDownloadUsers=()=>{
  toast.dismiss()
  const downloadReport= async(filters)=>{
       toast.loading(`Downloading Report`)
       try{

const {data}= await instance.get(`/api/user/all?pageNumber=${filters.pageNumber}&pageSize=${filters.pageSize}&search=${filters.search}&orgId=${filters.orgId}&download=true`, {
   responseType: 'blob', // important: treat it as a file
 })
console.log({data})
toast.dismiss()     
toast.success(`Downloaded`)

const blob = data;

// Convert CSV blob to Excel
const reader = new FileReader();
reader.onload = function (e) {
 const text = e.target.result;
 const workbook = XLSX.read(text, { type: 'string' });
 const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
 const excelBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
 saveAs(excelBlob, `Users_${Date.now()}.xlsx`);
};
reader.readAsText(blob);
// const worksheet = XLSX.utils.json_to_sheet(data);
// const workbook = XLSX.utils.book_new();
// XLSX.utils.book_append_sheet(workbook, worksheet, 'Report');

// const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
// const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

// saveAs(blob, `Manage_Report_${Date.now()}.xlsx`);

}
       catch(ex){
console.log({ex})
       }
   }
   const mutation= useMutation({
       mutationFn:downloadReport
   })
return mutation
}
// Add User
export const useAddUser = () => {
    const queryClient = useQueryClient();
    const addUserMutation = useMutation(async (newUser) => {
      const { data } = await instance.post('/api/add-user', newUser);
      return data;
    }, {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch users']); // Invalidate and refetch users
      },
    });
  
    return addUserMutation;
  };
  
  // Update User
  export const useUpdateUser = () => {
    const queryClient = useQueryClient();
    const updateUserMutation = useMutation(async (updatedUser) => {
      const { data } = await instance.put(`/api/users/${updatedUser.id}`, updatedUser); // Include user ID in URL
      return data;
    }, {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch users']); // Invalidate and refetch users
      },
    });
  
    return updateUserMutation;
  };
  
  // Delete User
  export const useDeleteUser = () => {
    const queryClient = useQueryClient();
    const deleteUserMutation = useMutation(async (userId) => {
      await instance.delete(`/api/user/${userId}`); // Include user ID in URL
    }, {
      onSuccess: () => {
        queryClient.invalidateQueries(['fetch users']); // Invalidate and refetch users
      },
    });
  
    return deleteUserMutation;
  };
  